import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-item px-3" }
const _hoisted_2 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_3 = { class: "symbol symbol-50px me-5" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_7 = { class: "fw-bold text-hover-secundary fs-7 text-break" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_9 = { class: "menu-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            alt: "Logo",
            style: {"object-fit":"cover"},
            src: 
              _ctx.user.imgUsuario
                ? _ctx.user.imgUsuario
                : 'https://www.fiscalti.com.br/wp-content/uploads/2021/02/default-user-image-365x365.png'
            
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.nome), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.procuraAcesso(_ctx.user.idCargo)), 1)
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link text-primario"
      }, "Sair")
    ])
  ]))
}